import React from 'react';
import { useIntl } from 'react-intl';
import type {
    OperationZoneDto,
    VatGroupWithRatesDto,
} from '@/services/innovorder/vatConfiguration/vatConfiguration.type';
import type { ConsumptionMode } from '../../VatRatesMatrix.viewmodel';
import { getVatGroupLabel } from '../../utils';
import { ExportButton, FilterSelect, FiltersContainer } from './MatrixFilters.style';

interface MatrixFiltersProps {
    zones: OperationZoneDto[];
    groups: VatGroupWithRatesDto[];
    zoneFilter: string;
    onZoneFilterChange: (value: string) => void;
    groupFilter: string;
    onGroupFilterChange: (value: string) => void;
    modeFilter: ConsumptionMode | '';
    onModeFilterChange: (value: ConsumptionMode | '') => void;
    onExportCsv: () => void;
}

export const MatrixFilters: React.FunctionComponent<MatrixFiltersProps> = ({
    zones,
    groups,
    zoneFilter,
    onZoneFilterChange,
    groupFilter,
    onGroupFilterChange,
    modeFilter,
    onModeFilterChange,
    onExportCsv,
}) => {
    const intl = useIntl();

    return (
        <FiltersContainer>
            <FilterSelect
                value={zoneFilter}
                onChange={(e) => onZoneFilterChange(e.target.value)}
                aria-label={intl.formatMessage({ id: 'vatRatesMatrix.filterByZone' })}
            >
                <option value="">{intl.formatMessage({ id: 'vatRatesMatrix.filterByZone' })}</option>
                {zones.map((zone) => (
                    <option key={zone.code} value={zone.code}>
                        {zone.name}
                    </option>
                ))}
            </FilterSelect>

            <FilterSelect
                value={groupFilter}
                onChange={(e) => onGroupFilterChange(e.target.value)}
                aria-label={intl.formatMessage({ id: 'vatRatesMatrix.filterByGroup' })}
            >
                <option value="">{intl.formatMessage({ id: 'vatRatesMatrix.filterByGroup' })}</option>
                {groups.map((group) => (
                    <option key={group.code} value={group.code}>
                        {getVatGroupLabel(intl, group)}
                    </option>
                ))}
            </FilterSelect>

            <FilterSelect
                value={modeFilter}
                onChange={(e) => onModeFilterChange(e.target.value as ConsumptionMode | '')}
                aria-label={intl.formatMessage({ id: 'vatRatesMatrix.filterByMode' })}
            >
                <option value="">{intl.formatMessage({ id: 'vatRatesMatrix.filterByMode' })}</option>
                <option value="eatIn">{intl.formatMessage({ id: 'vatRatesMatrix.eatIn' })}</option>
                <option value="takeAway">{intl.formatMessage({ id: 'vatRatesMatrix.takeAway' })}</option>
                <option value="delivery">{intl.formatMessage({ id: 'vatRatesMatrix.delivery' })}</option>
            </FilterSelect>

            <ExportButton onClick={onExportCsv}>{intl.formatMessage({ id: 'vatRatesMatrix.exportCsv' })}</ExportButton>
        </FiltersContainer>
    );
};
